import { BarChart3, MessageCircle, Zap } from "lucide-react";
import { StatCard, StatGrid, formatNumber, getTrend } from "./ui";

const KpiCards = ({ totals, previousTotals }: any) => {
  const cards = [
    { label: "Total AI Usage", value: totals.total_tokens || 0, icon: <Zap />, tone: "primary" as const, prev: previousTotals?.total_tokens || 0 },
    { label: "Questions Asked", value: totals.total_calls || 0, icon: <MessageCircle />, tone: "info" as const, prev: previousTotals?.total_calls || 0 },
    {
      label: "Avg AI Usage per Question",
      tooltip: "Average amount of AI processing used to answer each question",
      value: totals.total_calls ? Math.round(totals.total_tokens / totals.total_calls) : 0,
      icon: <BarChart3 />,
      tone: "success" as const,
      prev: previousTotals?.total_calls ? Math.round(previousTotals.total_tokens / previousTotals.total_calls) : 0,
    },
  ];

  return (
    <StatGrid className="md:grid-cols-3">
      {cards.map((card) => (
        <StatCard key={card.label} label={card.label} tooltip={card.tooltip} icon={card.icon} tone={card.tone}
          value={formatNumber(card.value)} trend={getTrend(card.value, card.prev)} />
      ))}
    </StatGrid>
  );
};

export default KpiCards;
